import { render, staticRenderFns } from "./pogs-reports__summary.vue?vue&type=template&id=2a7a5be4&"
import script from "./pogs-reports__summary.vue?vue&type=script&lang=js&"
export * from "./pogs-reports__summary.vue?vue&type=script&lang=js&"
import style0 from "./pogs-reports__summary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports